<div class="container">

  <form [formGroup]="longlineForm">

    <div class="row" *ngIf="isEdit">
      <h2 class="display-6" style="margin-bottom:0%">Gear Name</h2>
    </div>

    <div class="row" *ngIf="isEdit">
      <div class="col">
        <div class="row">
          <mat-form-field style="font-weight: bold;">
            <mat-label>Name</mat-label>
            <input matInput type="text" formControlName="name">
            <mat-hint>Leave blank to auto letter gear</mat-hint>
          </mat-form-field>
        </div>
      </div>
    </div>

    <br>
    <br>

    <div class="row">
      <h1 class="display-6" style="margin-bottom:0%">Longline Type</h1>
    </div>

    <br>

    <div class="row">
      <mat-form-field>
        <mat-select formControlName="longlineType" [compareWith]="compareFn" required>
          <mat-option *ngFor="let type of types" [value]="type">
            {{type}}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="longlineForm.invalid">Required</mat-error>
      </mat-form-field>
    </div>

    <br>

    <div class="row">
      <h1 class="display-6" style="margin-bottom:0%">Length of Skate or Line in Tub</h1>
    </div>

    <div class="row">
      <mat-form-field>
        <mat-label>Feet</mat-label>
        <input matInput type="text" inputmode="decimal" formControlName="skateLength" (input)="_forbidNonNumeric(longlineForm.get('skateLength')!)" required>
        <mat-error *ngIf="longlineForm.invalid">Required</mat-error>
      </mat-form-field>
    </div>

    <br>

    <div class="row">
      <h1 class="display-6" style="margin-bottom:0%">Hook Size</h1>
    </div>

    <div class="row">
      <div class="col">
        <div class="row">
          <mat-form-field>
            <input matInput type="text" inputmode="decimal" formControlName="hookSize" (input)="_forbidNonNumeric(longlineForm.get('hookSize')!)" required>
            <span matSuffix style="font-weight: bold;">/0</span>
            <mat-error *ngIf="longlineForm.invalid">Required</mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="row">
      <h1 class="display-6" style="margin-bottom:0%">Hook Spacing</h1>
    </div>

    <div class="row">
      <div class="col">
        <div class="row">
          <mat-form-field>
            <mat-label>Feet</mat-label>
            <input matInput type="text" inputmode="decimal" formControlName="hookSpace" (input)="_forbidNonNumeric(longlineForm.get('hookSpace')!)" required>
            <mat-error *ngIf="longlineForm.invalid">Required</mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>

    <br>

    <div class="row">
      <h1 class="display-6" style="margin-bottom:0%">Number of Hooks per Skate or Tub</h1>
    </div>

    <div class="row">
      <mat-form-field>
        <input matInput type="text" inputmode="decimal" formControlName="numHooksPerTub" (input)="_forbidNonNumeric(longlineForm.get('numHooksPerTub')!)" required>
        <mat-error *ngIf="longlineForm.invalid">Required</mat-error>
      </mat-form-field>
    </div>

    <br>

    <!--
    <div class="row">
        <h1 class="display-6" style="margin-bottom:0%">Total Number of Skates or Tubs Lost</h1>
    </div>

    <div class="row">
        <mat-form-field appearance="standard">
            <input matInput type="text" inputmode="decimal" formControlName="numSkatesLost" required>
            <mat-error *ngIf="longlineForm.invalid">Required</mat-error>
        </mat-form-field>
    </div>

    <br>
    -->

    <div class="row">
      <h1 class="display-6">Is Floating Longline?</h1>
      <br>
      <mat-radio-group aria-label="Select an option" formControlName="isFloating">
        <mat-radio-button value="{{true}}">Yes</mat-radio-button>
        <mat-radio-button [checked]="!longlineForm.get('isFloating')?.value" value="{{false}}" style="padding-left: 10px">No</mat-radio-button>
      </mat-radio-group>
    </div>

  </form>

  <!-- Cancel or create longline gear -->
  <div class="row justify-content-between" style="margin-top: 50px;" align="center">

    <button mat-stroked-button
            class="text-blue-button"
            type="button"
            aria-label="confirm"
            (click)="cancelEvent.emit('Longline')">
      Cancel
    </button>

    <button mat-stroked-button
            class="text-button"
            type="submit"
            aria-label="confirm"
            (click)="onConfirmBtnClick()">
      OK
    </button>

  </div>

</div>
